<template>
  <rs-select :items="items" v-bind="$attrs" v-on="$listeners" />
</template>

<script>
import { mapGetters } from "vuex";

import OptionsService from "@/core/services/options.service";

export default {
  props: {
    locationTypeId: {
      type: Number,
      required: true,
      default: null,
    },
    parentId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapGetters(["cityList"]),
  },
  watch: {
    cityList() {
      if (this.locationTypeId === 2) {
        this.setItems();
      }
    },
    locationTypeId() {
      this.setItems();
    },
    parentId() {
      this.setItems();
    },
  },
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.$nextTick(() => this.setItems());
  },
  methods: {
    setItems() {
      if (this.locationTypeId === 2) {
        this.items = this.cityList;
      } else if (this.locationTypeId === 3) {
        this.items = [];
        if (!this.parentId) {
          return;
        }

        const parentId = this.parentId;
        OptionsService.getDistrictList(parentId).then((list) => {
          if (this.locationTypeId === 3 && this.parentId === parentId) {
            this.items = list || [];
          }
        });
      } else {
        // eslint-disable-next-line
        console.info("Unused location type id: " + this.locationTypeId);
      }
    },
  },
};
</script>
